module.exports = __webpack_public_path__ + "img/telegram-2.a7aac00.svg?v=1751624816731";